<template>
  <div v-if="enabled" ref="containerRef" class="turnstile-widget flex justify-center"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const emit = defineEmits(['success', 'error', 'expired'])

const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY
const enabled = !!siteKey
const containerRef = ref(null)
let widgetId = null

function loadScript() {
  return new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
    script.async = true
    script.defer = true
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

async function render() {
  if (!enabled || !containerRef.value) return
  await loadScript()
  widgetId = window.turnstile.render(containerRef.value, {
    sitekey: siteKey,
    callback: (token) => emit('success', token),
    'error-callback': () => emit('error'),
    'expired-callback': () => emit('expired'),
    theme: 'auto',
    size: 'normal'
  })
}

function reset() {
  if (widgetId !== null && window.turnstile) {
    window.turnstile.reset(widgetId)
  }
}

defineExpose({ reset, enabled })

onMounted(() => {
  if (enabled) {
    render()
  }
})

onBeforeUnmount(() => {
  if (widgetId !== null && window.turnstile) {
    window.turnstile.remove(widgetId)
  }
})
</script>
